import * as React from 'react';
import RootV2 from './RootV2';

const AppContainer = () => {

    return <RootV2 />;

}


export default AppContainer;